import script from "./Touch.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Touch.vue?vue&type=script&setup=true&lang=ts"
export * from "./Touch.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Touch.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__